import * as React from "react";
import { Icon } from "../externals";
import "./PathSelector.scss";
const PathSelector = ({ id, name, iconName, isClicked, onClick, }) => {
    let className = isClicked
        ? "pathselector pathselector-clicked"
        : "pathselector";
    return (React.createElement("div", { className: className, onClick: () => {
            onClick(id);
        }, "data-testid": "path-selector" },
        React.createElement("div", { className: "pathselector-icon" },
            React.createElement(Icon, { icon: iconName, size: 16 })),
        name));
};
export default PathSelector;
//# sourceMappingURL=PathSelector.js.map